import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useTenantPage } from "./useTenantPage";

// Header quick switch between spaces: server-side search (never loads every tenant); hidden when the user has a single space.
export function AreaSwitch({ current, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const p = useTenantPage({ q: q.trim(), limit: 20 });
  if (!q && !p.loading && p.total <= 1) return null;
  return (
    <div className="w-48 sm:w-80">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" role="combobox" className="h-11 w-full justify-between sm:h-10 bg-white font-normal sm:w-80" data-testid="crm-tenant-select">
            <span className="truncate">{current?.name || "Scegli il cliente"}</span><ChevronsUpDown size={14} className="ml-2 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[calc(100vw-1rem)] max-w-[calc(100vw-1rem)] p-0 sm:w-[--radix-popover-trigger-width]" align="end" collisionPadding={8} data-testid="crm-tenant-popover">
          <Command shouldFilter={false}>
            <CommandInput value={q} onValueChange={setQ} placeholder="Cerca cliente…" data-testid="crm-tenant-search" />
            <CommandList>
              <CommandEmpty>{p.loading ? "Ricerca…" : "Nessun cliente trovato."}</CommandEmpty>
              {p.items.map((t) => (
                <CommandItem key={t.id} value={t.id} onSelect={() => { onChange(t.id); setOpen(false); }} className="min-h-[44px] sm:min-h-0" data-testid={`crm-tenant-option-${t.id}`}>
                  <Check size={14} className={`mr-2 shrink-0 ${t.id === current?.id ? "opacity-100" : "opacity-0"}`} /><span className="min-w-0 whitespace-normal break-words sm:truncate">{t.name}</span>
                </CommandItem>))}
              {p.has_more && <p className="px-3 py-2 text-[11px] text-slate-500" data-testid="area-switch-more">Altri {p.total - p.items.length}: affina la ricerca</p>}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
